import React from 'react';
import { useLocation } from 'react-router-dom';
// components
import Book from '../BookItem';
// hooks
import { useUserBooksFetch } from '../Hooks/useUserBooksFetch';
// react-bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';

import Image from 'react-bootstrap/Image';
// image
import NoBooksImage from '../../images/no_results_image.svg';

const UserBooksPage = () => {
  const { userBooksState, loading, error } = useUserBooksFetch();

  const location = useLocation();

  const listName = location.pathname
    .substring(location.pathname.lastIndexOf('/') + 1, location.pathname.length)
    .replaceAll('-', '_');

  const books = userBooksState.books_list.filter(
    (book) => book.listName === listName
  );

  let icon = <i class='bi bi-book pe-3'></i>;
  if (listName === 'finished') {
    icon = <i class='bi bi-bookmark-check pe-3'></i>;
  } else if (listName === 'plan_to_read') {
    icon = <i class='bi bi-calendar-heart pe-3'></i>;
  }

  return (
    <Container className={'py-5 px-5 text-center'}>
      <h1 style={{ color: 'var(--brandSecondary)' }}>
        {icon}
        {listName.replaceAll('_', ' ')}

        {books.length > 0 && `    ${books.length}`}
      </h1>
      {loading && (
        <div className={'my-5 text-center'}>
          <Spinner
            animation='border'
            variant='primary'
            className={'text-center'}
          />
        </div>
      )}
      {books.length > 0 ? (
        <Row>
          {books.map((book) => (
            <Col
              xs={6}
              md={4}
              lg={2}
              className={'text-center p-3'}
              key={book._id}
            >
              <Book book={book} source={listName} />
            </Col>
          ))}
        </Row>
      ) : (
        !loading && (
          <div className='mt-5'>
            <h2 className='mt-5'>No Books Added !</h2>
            <Image src={NoBooksImage} fluid />
          </div>
        )
      )}
    </Container>
  );
};

export default UserBooksPage;
